import { Tag } from 'antd';
const defCode = `
import { McRadarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State defOption: Options = new Options({
    title: {
      show: true,
      text: '基础雷达',
      right: 20,
      top: 30
    },
    radar: {
      indicator: [
        { name: '鸿蒙' },
        { name: 'ios'},
        { name: '安卓'},
        { name: 'Magic' },
        { name: '我心澎湃' },
        { name: '蓝河' }
      ]
    },
    series: [
      {
        name: '遥遥领先',
        data: [1000, 800, 600, 700, 266, 132]
      }
    ]
  })
  build() {
    Row() {
      McRadarChart({
        options: this.defOption
      })
    }
    .height('50%')
  }
}
`


const changeCode = `
import { McRadarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
   @State defOption: Options = new Options({
    title: {
      show: true,
      text: '基础雷达',
      right: 20,
      top: 30
    },
    radar: {
      indicator: [
        { name: '鸿蒙' },
        { name: 'ios'},
        { name: '安卓'},
        { name: 'Magic' },
        { name: '我心澎湃' },
        { name: '蓝河' }
      ]
    },
    series: [
      {
        name: '遥遥领先',
        data: [1000, 800, 600, 700, 266, 132]
      }
    ]
  })
  aboutToAppear() {
    setTimeout(() => {
      // 使用Option实例对象的setVal方法来实现，修改什么属性就传什么
      this.defOption.setVal({
        series: [
          {
            data: [110, 120, 150, 113, 120, 10, 10]
          }
        ]
      })
    }, 2000)
  }
  build() {
    Row() {
      McRadarChart({
        options: this.defOption
      })
    }
    .height('50%')
  }
}
`


const radarCode = `
import { McRadarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State legendOption: Options = new Options({
    radar: {
      indicator: [
        { name: '莓创图表' },
        { name: '莓创表格' },
        { name: '莓创表单' },
        { name: '莓创工具' },
        { name: '莓创生态' },
        { name: '莓创鸿蒙' }
      ],
      // 雷达图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标。
      center: ['50%', '50%'],
      radius: '70%', // 雷达图的半径。可以为如下类型：number | string
      startAngle: 90, // 坐标系起始角度，也就是第一个指示器轴的角度。
      nameGap: 10, // 指示器名称和指示器轴的距离。
      splitNumber: 5, // 指示器轴的分割段数。
      // 雷达图每个指示器名称的配置项。
      axisName: {
        show: true,
        color: '#999',
        fontWeight: 'normal',
        fontFamily: 'sans-serif',
        fontSize: 22,
        width: 30,
        // x轴的文本长度超出的处理， none（无）， truncate（截断），breakAll（换行）
        overflow: 'truncate'
      },
      // 坐标轴轴线相关设置。
      axisLine: {
        show: false,
        lineStyle: {
          color: '#DBDBDB',
          width: 1
        }
      },
      // 坐标轴在 grid 区域中的分隔线。
      splitLine: {
        show: false,
        lineStyle: {
          color: '#DBDBDB',
          width: 1
        }
      },
      // 坐标轴在 grid 区域中的分隔区域，默认显示。
      splitArea: {
        show: true,
        areaStyle: {
          colors: ['#fff','#ff2f5af3']
        }
      }
    },
    series:[
      {
        name: '莓创',
        data: [110, 120, 15, 13, 12, 10, 10]
      }
    ]
  })
  build() {
    Row() {
      McRadarChart({
        options: this.legendOption
      })
    }
    .height('50%')
  }
}
`

const polygonOption = `
import { McRadarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
   @State polygonOption: Options = new Options({
    title: {
      show: true,
      text: '圆形雷达',
      right: 20,
      top: 30
    },
    radar: {
      polygon: false,
      indicator: [
        { name: '鸿蒙' },
        { name: 'ios'},
        { name: '安卓'},
        { name: 'Magic' },
        { name: '我心澎湃' },
        { name: '蓝河' }
      ]
    },
    series: [
      {
        
        data: [1000, 800, 600, 700, 266, 132]
      }
    ]
  })
  build() {
    Row() {
      McRadarChart({
        options: this.legendOption
      })
    }
    .height('50%')
  }
}
`

const tooltipCode = `
import { McRadarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State tooltipOption: Options = new Options({
    title: {
      show: true,
      text: 'tooltip属性',
      right: 20,
      top: 30
    },
    tooltip: {
      borderColor: '#f72659f5',
      borderWidth: 1,
      backgroundColor: '#fff',
      textStyle: { // 文本样式配置
        color: '#000'
      }
    },
    radar: {
      indicator: [
        { name: '鸿蒙' },
        { name: 'ios'},
        { name: '安卓'},
        { name: 'Magic' },
        { name: '我心澎湃' },
        { name: '蓝河' }
      ]
    },
    series: [
      {
        name: '遥遥领先',
        data: [1000, 800, 600, 700, 266, 132]
      }
    ]
  })
  build() {
    Row() {
      McRadarChart({
        options: this.tooltipOption
      })
    }
    .height('50%')
  }
}
`

const cTooltipCode = `
import { McRadarChart, Options, chartInterface } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State tooltipOption: Options = new Options({
    title: {
      show: true,
      text: '自定义tooltip属性',
      right: 20,
      top: 30
    },
    radar: {
      indicator: [
        { name: '鸿蒙' },
        { name: 'ios'},
        { name: '安卓'},
        { name: 'Magic' },
        { name: '我心澎湃' },
        { name: '蓝河' }
      ]
    },
    series: [
      {
        name: '遥遥领先',
        data: [1000, 800, 600, 700, 266, 132]
      }
    ]
  })
  @Builder
  customTooltip($$: chartInterface.InterfaceObj) {
    if ($$.tooltipInfo.title) {
      Text($$.tooltipInfo.title)
    }
    ForEach($$.tooltipInfo.data, (item: chartInterface.InterfaceObj, index) => {
      Text(item.name + '：' + item.num)
    })
  };
  build() {
    Row() {
      McRadarChart({
        options: this.tooltipOption,
        customTooltip: this.customTooltip
      })
    }
    .height('50%')
  }
}
`

const seriesCode = `
import { McRadarChart, Options } from '@mcui/mccharts'

@Entry
@Component
struct Index {
  @State moreOption: Options = new Options({
    title: {
      show: true,
      text: '多组雷达',
      right: 20,
      top: 30
    },
    radar: {
      indicator: [
        { name: '鸿蒙' },
        { name: 'ios'},
        { name: '安卓'},
        { name: 'Magic' },
        { name: '我心澎湃' },
        { name: '蓝河' }
      ]
    },
    series: [
      {
        name: '遥遥领先',
        areaStyle: {
          show: true,
          color: ['red', '#ff265fe5']
        },
        data: [1000, 800, 600, 700, 266, 132]
      },
      {
        name: '远远超越',
        data: [550, 450, 300, 350, 122, 145]
      }
    ]
  })
  build() {
    Row() {
      McRadarChart({
        options: this.moreOption
      })
    }
    .height('50%')
  }
}
`

const columns = [
    {
        title: '名称',
        width: 180,
        dataIndex: 'name',
    },
    {
        title: '描述',
        width: 200,
        dataIndex: 'describe'
    },
    {
        title: '类型',
        dataIndex: 'type',
        render: (text) => <Tag color="orange">{text}</Tag>,
    },
    {
        title: '默认值',
        dataIndex: 'defVal'
    },
    {
        title: '必填',
        dataIndex: 'must',
        render: (text) => <Tag color="#2db7f5">{!text ? '否' : '是'}</Tag>,
    },
    {
        title: '备注',
        dataIndex: 'remarks'
    }
];

const commonData = [
    {
        name: 'grid',
        describe: '直角坐标系内绘图网格',
        type: 'Object',
        defVal: '{}',
        state: '',
        remarks: '用于设置上下左右四个边距，替代历史的cPaddingL、cPaddingT、cPaddingR、cPaddingB四个属性，不过最新版本也会兼容旧的使用方式',
        children: [
            {
                name: 'left',
                describe: '图表内容区距离左侧位置',
                type: 'String | Number',
                defVal: '10%',
                remarks: '',
            },
            {
                name: 'right',
                describe: '图表内容区距离右侧位置',
                type: 'String | Number',
                defVal: '8%',
                remarks: '',
            },
            {
                name: 'top',
                describe: '图表内容区距离顶部位置',
                type: 'String | Number',
                defVal: '40',
                remarks: '',
            },
            {
                name: 'bottom',
                describe: '图表内容区距离底部位置',
                type: 'String | Number',
                defVal: '30',
                remarks: '',
            }
        ]
    },
    {
        name: 'color',
        describe: '调色盘颜色列表',
        type: 'String[]',
        defVal: "['#296DFF', '#ff5495fd', '#ff1acffd', '#ff72e4fd', '#7B72F7', '#F85758', '#FFBF29', '#D1E9F9', '#F5FAFC', '#5A657A']",
        remarks: '',
    },
    {
        name: 'title',
        describe: '标题组件与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        state: '',
        children: [
            {
                name: 'show',
                describe: '控制标题显示与隐藏',
                type: 'Boolean',
                defVal: 'true',
                remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
                name: 'text',
                describe: '主标题文本，支持使用 \n 换行。',
                type: 'String',
                defVal: '',
                remarks: '',
            },
            {
                name: 'subtext',
                describe: '副标题文本，支持使用 \n 换行。',
                type: 'String',
                defVal: '',
                remarks: '',
            },
            {
                name: 'itemGap',
                describe: '主副标题之间的间距。',
                type: 'Number',
                defVal: "5",
                remarks: '',
            },
            {
                key: 69,
                name: 'left',
                describe: '标题左侧位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 70,
                name: 'right',
                describe: '标题右侧位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 71,
                name: 'top',
                describe: '标题顶部位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 72,
                name: 'bottom',
                describe: '标题底部位置',
                type: 'String | Number',
                defVal: "'auto'",
                state: '',
                remarks: '可以设置为 "auto"、百分比或具体数值。'
            },
            {
                key: 73,
                name: 'offset',
                describe: '标题偏移量',
                type: 'Array',
                defVal: '[0, -20]',
                state: '',
                remarks: '用于设置标题相对于默认位置的偏移量，第一个值为X轴偏移，第二个值为Y轴偏移。'
            },
            {
                key: 2,
                name: 'textStyle',
                describe: '文本样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 21,
                        name: 'color',
                        describe: '字体颜色',
                        type: 'String',
                        defVal: "#333",
                        remarks: '支持RGB、RGBA、十六进制格式',
                    },
                    {
                        key: 22,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: "18",
                        remarks: '',
                    },
                    {
                        key: 23,
                        name: 'fontWeight',
                        describe: '字体粗细',
                        type: 'String',
                        defVal: "normal",
                        remarks: '',
                    },
                    {
                        key: 25,
                        name: 'fontFamily',
                        describe: '字体样式',
                        type: 'String',
                        defVal: "sans-serif",
                        remarks: '',
                    },
                    {
                        key: 74,
                        name: 'textAlign',
                        describe: '文本对齐方式',
                        type: 'String',
                        defVal: "'center'",
                        state: '',
                        remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
                    },
                    {
                        key: 75,
                        name: 'textBaseline',
                        describe: '文本基线对齐方式',
                        type: 'String',
                        defVal: "'bottom'",
                        state: '',
                        remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
                    }
                ]
            },
            {
                key: 3,
                name: 'subtextStyle',
                describe: '文本样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '',
                children: [
                    {
                        key: 31,
                        name: 'color',
                        describe: '字体颜色',
                        type: 'String',
                        defVal: "#aaa",
                        remarks: '支持RGB、RGBA、十六进制格式',
                    },
                    {
                        key: 32,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: "12",
                        remarks: '',
                    },
                    {
                        key: 33,
                        name: 'fontWeight',
                        describe: '字体粗细',
                        type: 'String',
                        defVal: "normal",
                        remarks: '',
                    },
                    {
                        key: 35,
                        name: 'fontFamily',
                        describe: '字体样式',
                        type: 'String',
                        defVal: "sans-serif",
                        remarks: '',
                    },
                    {
                        key: 76,
                        name: 'textAlign',
                        describe: '文本对齐方式',
                        type: 'String',
                        defVal: "'center'",
                        state: '',
                        remarks: '可以设置为 "left"、"center" 或 "right"，分别表示左对齐、居中对齐和右对齐。'
                    },
                    {
                        key: 77,
                        name: 'textBaseline',
                        describe: '文本基线对齐方式',
                        type: 'String',
                        defVal: "'bottom'",
                        state: '',
                        remarks: '可以设置为 "top"、"middle" 或 "bottom"，分别表示顶部对齐、中部对齐和底部对齐。'
                    }
                ]
            }
        ],
        remarks: '详细默认值请查看title属性讲解',
    },
    {
        name: 'radar',
        describe: '雷达图坐标系组件功能配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看radar属性讲解',
    },
    {
        name: 'tooltip',
        describe: '提示层样式与功能配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '详细默认值请查看tooltip属性讲解',
    },
    {
        name: 'animation',
        describe: '是否开启动画。',
        type: 'Boolean',
        defVal: "true",
        state: '',
        remarks: '如果频繁更新数据建议将该属性设置为false',
    },
    {
        name: 'series',
        describe: '区域样式与功能配置',
        type: 'Object[]',
        defVal: "[ ... ]",
        must: true,
        remarks: '详细默认值请查看series属性讲解',
    }
];

const radarData = [
    {
        name: 'indicator',
        describe: '雷达图的指示器，用来指定雷达图中的多个变量（维度）',
        type: 'Array<{name: "xxx"}>',
        defVal: '[]',
        must: true,
        remarks: '数据内可传max来代表每个指标的最大值',
    },
    {
        name: 'center',
        describe: '中心（圆心）坐标',
        type: 'Array<String>',
        defVal: '["50%", "50%"]',
        remarks: '数组的第一项是横坐标，第二项是纵坐标。',
    },
    {
        name: 'radius',
        describe: '半径',
        type: 'String | Number',
        defVal: '65%',
        remarks: '',
    },
    {
        name: 'startAngle',
        describe: '坐标系起始角度',
        type: 'Number',
        defVal: '-Math.PI / 2',
        remarks: '第一个指示器轴的角度',
    },
    {
        name: 'nameGap',
        describe: '指示器名称和指示器轴的距离',
        type: 'Number',
        defVal: "10",
        remarks: '',
    },
    {
        name: 'splitNumber',
        describe: '指示器轴的分割段数',
        type: 'Number',
        defVal: "5",
        remarks: '',
    },
    {
        key: 85,
        name: 'polygon',
        describe: '是否启用多边形雷达图轴',
        type: 'Boolean',
        defVal: 'true',
        state: '',
        remarks: '设置为 true 时，启用多边形雷达图轴。'
    },
    {
        key: 3,
        name: 'axisName',
        describe: '雷达图指示器名称的配置项',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
              key: 30,
              name: 'show',
              describe: '控制文本标签显示与隐藏',
              type: 'Boolean',
              defVal: "true",
              remarks: '可选值：true(显示)、false(隐藏)',
            },
            {
              key: 31,
              name: 'color',
              describe: '字体颜色',
              type: 'String',
              defVal: "#333",
              remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
              key: 32,
              name: 'fontSize',
              describe: '字体大小',
              type: 'Number',
              defVal: "18",
              remarks: '',
            },
            {
              key: 33,
              name: 'fontWeight',
              describe: '字体粗细',
              type: 'String',
              defVal: "normal",
              remarks: '',
            },
            {
              key: 34,
              name: 'fontFamily',
              describe: '字体样式',
              type: 'String',
              defVal: "sans-serif",
              remarks: '',
            },
            {
              key: 35,
              name: 'width',
              describe: '文本显示宽度',
              type: 'Number',
              defVal: "30",
              remarks: '',
            },
            {
              key: 36,
              name: 'overflow',
              describe: '文字超出宽度是否截断或者换行。配置width时有效',
              type: 'String',
              defVal: "breakAll",
              remarks: '可选值：none（无）、 truncate（截断）、breakAll（换行）'
            }
        ]
    },
    {
      key: 4,
      name: 'axisLine',
      describe: '坐标轴轴线相关设置。',
      type: 'Object',
      defVal: "{ ... }",
      remarks: '',
      children: [
          {
            key: 40,
            name: 'show',
            describe: '控制文轴线显示与隐藏',
            type: 'Boolean',
            defVal: "true",
            remarks: '可选值：true(显示)、false(隐藏)',
          },
          {
            key: 41,
            name: 'lineStyle',
            describe: '轴线样式配置',
            type: 'Object',
            defVal: "{ ... }",
            remarks: '',
            children: [
              {
                key: 411,
                name: 'color',
                describe: '轴线颜色',
                type: 'String',
                defVal: "#DBDBDB",
                remarks: '支持RGB、RGBA、十六进制格式',
              },
              {
                key: 412,
                name: 'width',
                describe: '轴线宽度',
                type: 'Number',
                defVal: "1",
                remarks: '',
              }
            ]
          }
      ]
    },
    {
      key: 5,
      name: 'splitArea',
      describe: '坐标轴在 grid 区域中的分隔区域',
      type: 'Object',
      defVal: "{ ... }",
      remarks: '',
      children: [
          {
            key: 50,
            name: 'show',
            describe: '控制分割区域显示与隐藏',
            type: 'Boolean',
            defVal: "true",
            remarks: '可选值：true(显示)、false(隐藏)',
          },
          {
            key: 51,
            name: 'areaStyle',
            describe: '区域样式配置',
            type: 'Object',
            defVal: "{ ... }",
            remarks: '',
            children: [
              {
                key: 511,
                name: 'colors',
                describe: '分隔区域颜色',
                type: 'Array<String>',
                defVal: "['#fff','rgba(200,200,200,0.2)']",
                remarks: '分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。',
              }
            ]
          }
      ]
    }
];

const tooltipData = [
    {
        name: 'show',
        describe: '控制提示层显示与隐藏',
        type: 'Boolean',
        defVal: 'true',
        remarks: '可选值：true(显示)、false(隐藏)',
    },
    {
        name: 'type',
        describe: '提示层显示类型',
        type: 'String',
        defVal: 'default',
        remarks: '可选值：default（默认）、custom（自定义）。需要注意是自定义需要配合监控点击方法回调，通过回调信息自行显示内容与位置',
    },
    {
        name: 'backgroundColor',
        describe: '提示框背景颜色',
        type: 'String',
        defVal: 'rgba(50,50,50,0.7)',
        remarks: '',
    },
    {
        name: 'borderColor',
        describe: '提示框边框颜色',
        type: 'String',
        defVal: "#333",
        remarks: '',
    },
    {
        name: 'borderWidth',
        describe: '提示框边框宽度',
        type: 'Number',
        defVal: "0",
        remarks: '',
    },
    {
        name: 'padding',
        describe: '提示框内边距',
        type: 'Number',
        defVal: "10",
        remarks: '',
    },
    {
        key: 2,
        name: 'textStyle',
        describe: '文本样式配置',
        type: 'Object',
        defVal: "{ ... }",
        remarks: '',
        children: [
            {
                key: 21,
                name: 'color',
                describe: '字体颜色',
                type: 'String',
                defVal: "#333",
                remarks: '支持RGB、RGBA、十六进制格式',
            },
            {
                key: 22,
                name: 'fontSize',
                describe: '字体大小',
                type: 'Number',
                defVal: "18",
                remarks: '',
            },
            {
                key: 23,
                name: 'fontWeight',
                describe: '字体粗细',
                type: 'String',
                defVal: "normal",
                remarks: '',
            },
            {
                key: 25,
                name: 'fontFamily',
                describe: '字体样式',
                type: 'String',
                defVal: "sans-serif",
                remarks: '',
            }
        ]
    }
];


const seriesData = [
    {
        name: 'name',
        describe: '系列名称，用于tooltip的显示，legend 的图例筛选',
        type: 'String',
        defVal: "空",
        remarks: '',
    },
    {
      key: 41,
      name: 'areaStyle',
      describe: '区域填充样式。设置后显示成区域面积图。',
      type: 'Object',
      defVal: "{}",
      state: '',
      remarks: '渐变方式已替换为新的，会兼容历史的使用方式',
      children: [
          {
              key: 86,
              name: 'show',
              describe: '是否显示雷达图区域填充',
              type: 'Boolean',
              defVal: 'false',
              state: '',
              remarks: '设置为 true 时，显示雷达图区域的填充。'
          },
          {
              key: 87,
              name: 'color',
              describe: '填充的颜色',
              type: 'String | Array',
              defVal: 'null',
              state: '',
              remarks: '可以设置为单个颜色值或颜色数组渐变。支持RGB、RGBA、十六进制格式。'
          },
          {
              key: 411,
              name: 'color',
              describe: '填充的颜色。',
              type: 'String|Object',
              defVal: "",
              state: 'del',
              remarks: '支持RGB、RGBA、十六进制格式。可通过设置object的模式来设置渐变色效果，具体使用方式请看示例代码。',
          }
      ]
    },
    {
        key: 89,
        name: 'point',
        describe: '雷达图点配置',
        type: 'Object',
        defVal: "{ ... }",
        state: '',
        remarks: '用于配置雷达图上的点的显示、半径和样式。',
        children: [
            {
                key: 891,
                name: 'show',
                describe: '是否显示雷达图点',
                type: 'Boolean',
                defVal: 'false',
                remarks: '设置为 true 时，显示雷达图上的点。'
            },
            {
                key: 892,
                name: 'radius',
                describe: '点的半径',
                type: 'Number',
                defVal: '2',
                remarks: '设置雷达图点的半径。'
            },
            {
                key: 893,
                name: 'style',
                describe: '雷达图点默认样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '用于配置雷达图点的默认样式，包括颜色、边框宽度和边框颜色。',
                children: [
                    {
                        key: 8931,
                        name: 'color',
                        describe: '颜色',
                        type: 'String',
                        defVal: "'#fff'",
                        remarks: '支持RGB、RGBA、十六进制格式。'
                    },
                    {
                        key: 8932,
                        name: 'borderWidth',
                        describe: '边框宽度',
                        type: 'Number',
                        defVal: '1',
                        remarks: '设置雷达图点的边框宽度。'
                    },
                    {
                        key: 8933,
                        name: 'borderColor',
                        describe: '边框颜色',
                        type: 'String',
                        defVal: "''",
                        remarks: '支持RGB、RGBA、十六进制格式。'
                    }
                ]
            }
        ]
    },
    {
        key: 90,
        name: 'label',
        describe: '雷达图标签配置',
        type: 'Object',
        defVal: "{ ... }",
        state: '',
        remarks: '用于配置雷达图标签的显示、偏移、间隙、格式化和样式。',
        children: [
            {
                key: 901,
                name: 'show',
                describe: '是否显示雷达图标签',
                type: 'Boolean',
                defVal: 'false',
                remarks: '设置为 true 时，显示雷达图标签。'
            },
            {
                key: 902,
                name: 'offset',
                describe: '标签位置偏移',
                type: 'Array',
                defVal: '[0, 0]',
                remarks: '用于设置标签相对于默认位置的偏移量，第一个值为X轴偏移，第二个值为Y轴偏移。'
            },
            {
                key: 903,
                name: 'labelGap',
                describe: '标签与雷达图之间的间隙',
                type: 'Number',
                defVal: '5',
                remarks: '设置标签与雷达图之间的距离。'
            },
            {
                key: 904,
                name: 'formatter',
                describe: '标签格式化',
                type: 'String | Function',
                defVal: 'null',
                remarks: '支持字符串模板和回调函数。例如，可以设置为 "Score-{value}" 或 (label) => (label)。'
            },
            {
                key: 905,
                name: 'style',
                describe: '雷达图标签默认样式配置',
                type: 'Object',
                defVal: "{ ... }",
                remarks: '用于配置雷达图标签的默认样式，包括字体大小和颜色。',
                children: [
                    {
                        key: 9051,
                        name: 'fontSize',
                        describe: '字体大小',
                        type: 'Number',
                        defVal: '20',
                        remarks: '设置标签的字体大小。'
                    },
                    {
                        key: 9052,
                        name: 'color',
                        describe: '颜色',
                        type: 'String',
                        defVal: "''",
                        remarks: '支持RGB、RGBA、十六进制格式。'
                    }
                ]
            }
        ]
    },
    {
      key: 56,
      name: 'data',
      describe: '折线图数据',
      type: 'Array<String|Number|Object>',
      defVal: '[]',
      state: '',
      must: true,
      remarks: '可以包含数值或对象，例如 [100, 200, {value: 100, ...xxx}]。'
  }
];


const anchorItems = [
  {
      key: '1',
      href: '#radar',
      title: 'radar属性',
  },
    {
      key: '11',
      href: '#polygonOption',
      title: '圆角模式',
  },
  {
      key: '4',
      href: '#tooltip',
      title: 'tooltip属性'
  },
  {
      key: '6',
      href: '#series',
      title: 'series属性'
  }
]



export {
    defCode,
    changeCode,
    radarCode,
    polygonOption,
    tooltipCode,
    cTooltipCode,
    seriesCode,
    columns,
    commonData,
    radarData,
    tooltipData,
    seriesData,
    anchorItems
}
